<template>
  <component :is="currentComponent"></component>
</template>

<script>
import IMIVVitaminTherapiesContentEn from './IMIVVitaminTherapiesContent/IMIVVitaminTherapiesContentEn.vue';
import IMIVVitaminTherapiesContentPtBR from './IMIVVitaminTherapiesContent/IMIVVitaminTherapiesContentPtBR.vue';
import IMIVVitaminTherapiesContentEs from './IMIVVitaminTherapiesContent/IMIVVitaminTherapiesContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return IMIVVitaminTherapiesContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return IMIVVitaminTherapiesContentEs;
      }
      return IMIVVitaminTherapiesContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
